import React, { useEffect, useState } from 'react';
import { APIROOT } from '../../Helpers/configs';

import { filterMethod } from '../../Helpers/helpers';

import { Autocomplete, TextField } from '@mui/material';

const TechAutocomplete = (props) => {
  const filterData = props.filterData;
  const nameLabel = props.nameLabel;
  const size = props.size;
  const [usersList, setUsersList] = useState([]);
  const userActive = props.userActive;
  const usersType = 'technician';
  const [selectedUser, setSelectedUser] = useState(
    null
    // {
    // id: '185696',
    // name: 'All Users',
    // }
  );

  const handleChange = (event, newValue) => {
    const filter = newValue ? (newValue.name === null ? '%' : newValue) : '%';
    setSelectedUser(newValue);
    filterData(filter);
  };

  useEffect(() => {
    getUsers(userActive, usersType).then((data) => {
      let users = [
        ...data.data.value,
        // {
        //   id: '185696',
        //   name: 'All Users',
        // },
      ];
      setUsersList(users);
    });
  }, [userActive, usersType]);

  const UserRows = () =>
    usersList.map((obj) => ({
      id: obj.id,
      name: obj.name,
    }));

  return (
    <div style={{ margin: '10px 0' }}>
      <Autocomplete
        // sx={{
        //   width: '100%',
        //   background: '#ffffff',
        //   padding: 0,
        // }}
        name='userName'
        key='userName'
        id='userName'
        // variant='standard'
        // size={size}
        value={selectedUser}
        onChange={handleChange}
        // disablePortal
        options={usersList}
        filterOptions={filterMethod}
        getOptionLabel={(option) => option.name}
        renderInput={(params) => <TextField {...params} label={nameLabel} />}
      />
    </div>
  );
};

export default TechAutocomplete;

async function getUsers(active, type) {
  let JWT = localStorage.getItem('JWT_Key');
  let headers = {
    'content-type': 'application/JSON',
  };

  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  let body = {
    pagereq: {
      filter: {
        fullfilter: [
          {
            field: 'active',
            search: active,
            strict: true,
          },
          {
            field: 'type',
            search: type,
            strict: true,
          },
        ],
      },
    },
  };

  const request = new Request(`${APIROOT}/api/usersv2`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });
  const response = await fetch(request);

  const data = response.json();
  return data;
}
